import { PackageOffer } from '@/slw/entities/package';
import { Button } from '@/slw/shared/ui/button';

interface ExclusiveOfferingCardProps {
  offering: PackageOffer;
  onSelect: (offering: PackageOffer) => void;
}

export function ExclusiveOfferingCard({ offering, onSelect }: ExclusiveOfferingCardProps) {
  return (
    <div className='flex flex-row bg-transparent gap-6 items-center'>
      <div className='flex flex-row gap-1 whitespace-nowrap '>
        <span className='text-[#FFCC00] text-[1rem] font-semibold uppercase '>{offering.slotPerPurchase} slots</span>
        <span className='text-white text-[1rem] font-semibold '>in</span>
        <span className='text-[#FFCC00] text-[1rem] font-semibold uppercase'>{offering.availablePeriod} days</span>
      </div>
      <span className='text-2xl text-white  font-bold'>${offering.pricePerPurchase}</span>
      <Button variant='default' color='primary' onClick={() => onSelect(offering)}>
        SELECT
      </Button>
    </div>
  );
}
